import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import './Ready.css'; // External CSS file for styles

const Ready = () => {

  const handleScrollTo = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    } else {
      console.warn(`Element with id ${sectionId} not found`);
    }
  };

  return (
    <div className='ready-container'>
      <div className='text-container-main'>
        <h1 className='ready-heading'>
          Ready to <em style={{
            fontFamily: 'instrument-serif'
          }}>Amplify</em> your <br/>brand with Next-Gen Marketing?
        </h1>
      </div>

      <div className='description-container-paragraph'>
        <p className='description-paragraph'>
        Achieve sustainable growth, build authentic visibility, and scale impact through a balance of organic influence <br></br>
         and strategic paid ads, a system designed to help your brand grow and perform consistently.
        </p>
      </div>

      <div className='ready-button-container'>
        <motion.button
          className='primary-button'
          whileHover={{
            boxShadow:
              '0 0 5px #fd4635, 0 0 10px #fd4635, 0 0 15px white, 0 0 20px black',
            transition: { duration: 0.5 },
          }}
          whileTap={{
            scale: 0.9,
            transition: { duration: 0.2 },
          }}
          onClick={() => handleScrollTo('book-call')}
        >
          <Link className='link' >
            Book a Call
          </Link>
        </motion.button>
        <a href='mailto:futureethicsmedia@gmail.com' style={{textDecoration: 'none'}}>
          <motion.button
            className='secondary-button'
            whileHover={{
              // boxShadow:
              //   '0 0 5px #fd4635, 0 0 10px #fd4635, 0 0 15px white, 0 0 20px black',
              // transition: { duration: 0.5 },
              background: 'black'
            }}
            whileTap={{
              scale: 0.9,
              transition: { duration: 0.2 },
            }}
          >
            Learn More
          </motion.button>
        </a>
      </div>
    </div>
  );
};

export default Ready;
